import { Reveal, SectionHead } from "./Reveal";

const HARDWARE = ["Cinema Camera Systems", "ARRI-Style Lighting Rigs", "Gimbal & Movement", "Wireless Monitoring", "On-Set Sound"];
const AI_TOOLS = ["Midjourney Concept Frames", "ComfyUI Pipelines", "Runway Motion Gen", "Luma Previs", "AI-Camera Hybrids"];

const Panel = ({ eyebrow, title, img, alt, items, delay }) => (
  <Reveal delay={delay} className="group border border-line bg-ink overflow-hidden">
    <div className="relative h-64 sm:h-80 overflow-hidden">
      <img src={img} alt={alt} className="img-cine w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink to-transparent" />
      <span className="absolute top-5 left-5 font-mono text-[10px] uppercase tracking-[0.3em] text-acid bg-obsidian/70 backdrop-blur-sm px-3 py-2">{eyebrow}</span>
    </div>
    <div className="p-8 sm:p-10">
      <h3 className="font-head text-2xl sm:text-3xl font-bold uppercase tracking-tight text-cream">{title}</h3>
      <ul className="mt-6 space-y-3">
        {items.map((t, i) => (
          <li key={t} className="flex items-center gap-4 border-b border-line pb-3 last:border-b-0">
            <span className="font-mono text-[10px] text-dim">0{i + 1}</span>
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-smoke">{t}</span>
          </li>
        ))}
      </ul>
    </div>
  </Reveal>
);

export const Production = () => (
  <section data-testid="camera-production-section" className="bg-ink border-y border-line py-28 sm:py-40">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-10">
      <SectionHead num="06" eyebrow="The Arsenal" title="Camera / Production" />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <Panel
          eyebrow="Captured"
          title="Real Hardware"
          img="https://images.unsplash.com/photo-1612548403247-aa2873e9422d?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Professional cinema camera"
          items={HARDWARE}
        />
        <Panel
          eyebrow="Generated"
          title="AI Toolstack"
          img="https://images.pexels.com/photos/34516665/pexels-photo-34516665.jpeg?auto=compress&cs=tinysrgb&w=940"
          alt="Studio lighting setup"
          items={AI_TOOLS}
          delay={0.15}
        />
      </div>
      <Reveal className="mt-10">
        <p className="font-head text-lg sm:text-2xl uppercase tracking-tight text-smoke">
          You master both — because the next decade of film is <span className="text-acid">shot and synthesized.</span>
        </p>
      </Reveal>
    </div>
  </section>
);
